export default {
  getRoles() {
    const raw = localStorage.getItem("role");
    if (!raw) return [];

    let parsed;

    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      console.warn("Невозможно разобрать роли:", e);
      return [];
    }

    const rolesArr = Object.values(parsed);

    if (!Array.isArray(rolesArr)) return [];

    return rolesArr.filter(role => typeof role === "string");
  },

  getNumber(num) {
    if (Number.isInteger(num)) {
      return num
    }
    else {
      let floatNumber = num.toFixed(1)
      let residue = floatNumber % 1
      if(residue == 0) return num.toFixed(0)
      else return floatNumber
    }
  },

  textTranslate(str){
    var answer = '';
    var converter = {
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
      'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
      'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
      'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
      'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
      'ш': 'sh', 'щ': 'sch', 'ь': '', 'ы': 'y', 'ъ': '',
      'э': 'e', 'ю': 'yu', 'я': 'ya',
  
      'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D',
      'Е': 'E', 'Ё': 'E', 'Ж': 'Zh', 'З': 'Z', 'И': 'I',
      'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
      'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T',
      'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C', 'Ч': 'Ch',
      'Ш': 'Sh', 'Щ': 'Sch',  'Ь': '', 'Ы': 'Y', 'Ъ': '',
      'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya', 
      
      ' ': '-', '!': '', '\"': '', '\\': '', '#': '', 
      '№': '', ';': '', '$': '', '%': '', '^': '', 
      '&': '', '*': '', '(': '', ')': '', ':': '', 
      '?': '', '<': '', '>': '', '.': '', ',': '', '|': '',
      '/': '', '~': '', '`': '', '=': '', '@': '', '+': ''
    };
  
    for (let i in str) {
      if (converter[str[i]] == undefined){
        answer += str[i];
      } else {
        answer += converter[str[i]];
      }
    }
  
    return answer;
  },

  isAdmin(roles) {
    return roles.includes("ROLE_ADMIN");
  },
  isHR(roles) {
    return roles.includes("ROLE_USER");
  },
  isInterviewer(roles) {
    return roles.includes("ROLE_INTERVIEWER");
  },
  isTeamLead(roles) {
    return roles.includes("ROLE_TEAM_LEAD");
  },

  // Может видеть пользователей, если админ или есть подчиненные
  canSeeUsers(roles) {
    return this.isAdmin(roles) || this.isHR(roles) || this.isInterviewer(roles);
  },

  // Может изменять сущности. пока что только админ
  canChangeEntities(roles) {
    return this.isAdmin(roles);
  },


  // Может видеть Назначение
  canSeeAppointment(roles) {
    return this.isAdmin(roles) || this.isHR(roles) || this.isInterviewer(roles);
  },

  // Может видеть Интервью
  canSeeInterviews(roles) {
    return this.isAdmin(roles) || this.isHR(roles) || this.isInterviewer(roles);
  },

  // Interview
  interviewStatusLabels() {
    return {
      created: "Создано",
      in_progress: "В процессе",
      pending: "На рассмотрении",
      declined: "Отклонено",
      accepted: "Принято",
      offer_sent: "Отправлен оффер"
    };
  },

  interviewStatusClass() {
    return {
      created: "interview-created-tag",
      in_progress: "interview-in_progress-tag",
      pending: "interview-pending-tag",
      declined: "interview-declined-tag",
      accepted: "interview-accepted-tag",
      offer_sent: "interview-offer_sent-tag"
    };
  },

  interviewUserType() {
    return {
      owned: "Инициатор",
      participated: "Участник",
      interviewed: "Кандидат",
    };
  },

  // User
  userStatus() {
    return {
      working: "работает",
      blank: "новый",
      declined: "отклонен",
      fired: "уволен",
      interviewing: "интервью",
    };
  },
  userStatusClass() {
    return {
      working: "user-status-working-tag",
      blank: "user-status-blank",
      declined: "user-status-declined",
      fired: "user-status-fired",
      interviewing: "user-status-interviewing",
    };
  },

}